<mat-radio-group
  class="flex"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [required]="props.required"
  
>
  <mat-radio-button (change)="radioChange()"
    class="history-year"
    *ngFor="let option of props.options | formlySelectOptions : field | async; let i = index"
    [id]="id + '_' + i"
    [color]="props.color"
    [labelPosition]="props.labelPosition"
    [disabled]="option.disabled"
    [value]="option.value"
  >
    <p class="label" [innerText]="option.label"></p>
  </mat-radio-button>
</mat-radio-group>
